import Axios, {AxiosInstance} from "axios";
import AddressApi from "./AddressApi";

export interface SelfServiceSignupAddressApiDto {
	/**
	 * Optional: rural and small-town Irish addresses often have no street name, and the Eircode identifies
	 * them on its own.
	 */
	street?: string | null;
	city: string;
	eircode: string;
	buildingName?: string;
	buildingNumber?: string;
	subBuilding?: string;
	secStreet?: string;
	district?: string;
	province?: string;
}

export interface SelfServiceSignupApiDto {
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber: string;
	driverLicenceNumber?: string;
	businessName: string;
	address: SelfServiceSignupAddressApiDto;
	turnstileToken: string;
	jobTypes: string[];
	sendSetPasswordEmail?: boolean;
	/**
	 * Journey this registration came from, e.g. TAXI_WEB. Optional, and what the backend reads to decide
	 * whether the new Partner Brand gets a cap on its mileage payouts: the taxi journey's drivers are paid
	 * in full, everyone else inherits the brand's cap. Left out means capped.
	 */
	source?: string;
}

export interface SelfServiceSignupResponseApiDto {
	accessToken?: string;
	expiresIn?: number;
	partnerBrandId: string;
	userId: string;
	utilityName?: string;
}

/**
 * Public signup API. It deliberately uses an axios instance without the portal's auth/logout interceptors.
 */
export default class SelfServiceSignupApi {
	public readonly addressApi: AddressApi;

	constructor(public readonly axiosInstance: AxiosInstance = Axios.create({timeout: 30000})) {
		this.addressApi = new AddressApi(axiosInstance, "/api/web/partner-signup/addresses");
	}

	signUp(data: SelfServiceSignupApiDto): Promise<void> {
		return this.axiosInstance.post("/api/web/partner-signup", data).then(() => undefined);
	}

	/**
	 * Creates an account for a journey that continues with bearer-authenticated mobile endpoints.
	 * The caller owns the token and must keep it in memory only.
	 */
	createAccount(data: SelfServiceSignupApiDto): Promise<SelfServiceSignupResponseApiDto> {
		return this.axiosInstance.post("/api/web/partner-signup", data).then(response => response.data);
	}
}

export const selfServiceSignupApi = new SelfServiceSignupApi();
